module.exports = __webpack_public_path__ + "img/dark.675e88dd.jpg";